import styled from "styled-components";
import { shimmer } from "../../../styles/animations";

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  background: #f6f7f8;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 200px 100%;
  ${shimmer()}
  height: 40px;
  margin: 10px 0;
  border-radius: 24px;
`;

export const SkeletonCell = styled.div`
  flex: 1;
  margin: 0 5px;
  height: 100%;
`;
